export default "__VITE_ASSET__$CpwppAS__"